import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import FileItem from "./FileItem";
import { useTheme } from "@emotion/react";
import { AuthContext } from "../../../context/AuthContext";

// Defines how many cards to show at each screen width breakpoint
const responsive = {
  xl: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 1200 },
    items: 4,
  },
  lg: {
    breakpoint: { max: 1199, min: 900 },
    items: 4,
  },
  md: {
    breakpoint: { max: 899, min: 680 },
    items: 3,
  },
  sm: {
    breakpoint: { max: 679, min: 453 },
    items: 2,
  },
  xs: {
    breakpoint: { max: 452, min: 0 },
    items: 1,
  },
};

const EmployeeDocuments = ({ documents, userId }) => {
  const [loading, setLoading] = useState(false);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [openPreview, setOpenPreview] = useState(false);

  //   const addJobDoc = async (fileDataList: any[]) => {
  //     try {
  //       setLoading(true);
  //       for (let fileData of fileDataList) {
  //         let fileBlob = fileData.file;
  //         let fileName = fileData.fileCustomName + "." + fileData.fileExtension;
  //         let uuidFileName = uuidv4() + "." + fileData.fileExtension;

  //         // Upload to S3

  //         let file = null;
  //         if (fileBlob.type.startsWith("image/"))
  //           file = await compressImage(fileBlob, fileBlob.type);
  //         else file = fileBlob;

  //         let s3Key = `job/${jobId}/documents/${uuidFileName}`;

  //         const presignedUrl = await createWritePresignedUrl(s3Key);
  //         await upload(presignedUrl, file);

  //         // Update AccountDetails.profilePicture
  //         let apiUri = `/api/jobs/${jobId}/documents`;
  //         const response = await fetch(apiUri, {
  //           // signal: controller.signal,
  //           method: "POST",
  //           body: JSON.stringify({
  //             s3key: s3Key,
  //             name: fileName,
  //             fileType: file.type,
  //             documentType,
  //           }),
  //         });
  //         // if (!response.ok) {
  //         //   throw await response.json();
  //         // }
  //       }

  //       getJobDocuments();
  //       onJobDocReloaded();
  //       return true;
  //     } catch (error) {
  //       console.log(error);
  //       return false;
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   const deleteJobDoc = async (jobDocId: number) => {
  //     try {
  //       setLoading(true);

  //       // Update AccountDetails.profilePicture
  //       const response = await fetch(`/api/jobs/${jobId}/documents/${jobDocId}`, {
  //         // signal: controller.signal,
  //         method: "DELETE",
  //       });
  //       if (!response.ok) {
  //         throw await response.json();
  //       }

  //       getJobDocuments();
  //       onJobDocReloaded();
  //       return true;
  //     } catch (error) {
  //       console.log(error);
  //       return false;
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", marginTop: "32px" }}>
      {/* <Box sx={{ display: "flex", alignItems: "center" }}>
        <FilePicker
          title={
            documentType == DocumentType.FINISH
              ? "Finish Photos & Docs"
              : "Initial Photos & Docs"
          }
          disabled={readOnly}
          onSubmit={async (fileDataList: any) => {
            return await addJobDoc(fileDataList);
          }}
          allowCamera={true}
          allowFileUpload={true}
        />
      </Box> */}
      <Typography variant="h6">Employee Documents</Typography>
      <Carousel responsive={responsive}>
        {documents &&
          documents.map((doc, index) => {
            return (
              <FileItem
                key={doc.id}
                // readOnly={!allowDelete}
                fileItem={doc}
                // onDelete={() => {
                //   deleteJobDoc(doc.id);
                // }}
                // onItemClick={() => {
                //   if (!disableCarouselPreview) setOpenPreview(true);
                // }}
              />
            );
          })}
      </Carousel>
      {/* Preview Dialog */}
      <Dialog
        scroll={"paper"}
        maxWidth="md"
        fullWidth={true}
        fullScreen={isSmallScreen}
        open={openPreview}
        onClose={() => {
          setOpenPreview(false);
        }}
      >
        <DialogTitle>Preview</DialogTitle>

        <Box sx={{ height: "100%" }}>
          <Carousel responsive={responsive}>
            {documents &&
              documents.map((doc, index) => {
                return (
                  <FileItem
                    key={doc.id}
                    // readOnly={!allowDelete}
                    document={doc}
                    // onDelete={() => {
                    //   deleteJobDoc(doc.id);
                    // }}
                  />
                );
              })}
          </Carousel>
        </Box>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenPreview(false);
            }}
          >
            Back
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default EmployeeDocuments;
